import { GlobalConfigType, setApplicationStep } from 'actions'
import cloneDeep from 'clone-deep'
import { LoanFieldProps } from 'config'
import { store } from 'reducers'

import { BorrowerSeperator } from '../config'
import { borrowerMenuKey } from '../util'

export const signMldsValidate = (borrowerSeperator: BorrowerSeperator, updateStore = false) => {
  const { borrower, step, globalConfigReducer } = store.getState()

  const loanFieldProperties = globalConfigReducer[GlobalConfigType.LoanFields] as LoanFieldProps
  if (((loanFieldProperties as any)['visibility'] || {})['mlds'] === false) {
    return true
  }

  let success = true
  const data = borrower[borrowerSeperator]
  if (!data || !data.signedMldsPdfKey) success = false
  if (data?.mldsOverriden || data?.mldsExempt) success = true

  if (updateStore) {
    let application = cloneDeep(step.application)
    const key = borrowerMenuKey(borrowerSeperator, 'mlds')
    application[key] = success ? 1 : -1
    store.dispatch(setApplicationStep(application))
  }

  return success
}
